module.exports = __webpack_public_path__ + "static/img/djys_video_bg.f815aa5b.png";